import { InfoValue } from "@/services/channels/types";

export interface StageDtoIn {
    solutionId: string,
    playerId: string
}

export interface Stage {
    id: string,
    name: string,
    width: number,
    height: number,
    expandedWidth: number,
    expandedHeight: number,
    useExpandedDimensionsForTemplate: boolean,
    contentTimeout: number
    stageContent: Array<Content>;
}

export interface Settings {
    name: string,
    width: number,
    height: number,
    expandedWidth: number,
    expandedHeight: number,
    useExpandedDimensionsForTemplate: boolean;
    contentTimeout: number
}

export interface Content {
    id: string,
    contentId: string,
    stageId: string,
    name: string,
    channelId?: string,
    channelGroupId?: string,
    templateId?: string,
    isDefault?: boolean,
    eventName?: string,
    interactionBehavior: string,
    returnToFirstPostTime: number,
    showFirstPost: boolean,
    menuStyleId: string | null,
    active: boolean,
    contentType: ContentType
}

export interface StageInfo {
    name: string,
    height: number,
    width: number,
    solutions: Array<InfoValue>,
    designs: Array<InfoValue>
}

export interface StageFilters {
    solutions: Array<InfoValue>,
    designs: Array<InfoValue>
}

export interface Filter {
    solutionId: string,
    designId: string
}

export enum InteractionBehavior
{
    none = "none",
    menu = "menu",
    menuFlat = "menuFlat"
}

export enum ContentType {
    Channel,
    ChannelGroup,
    Design
}
